@if (showFloatingActionButton$ | async) {
	@if (prompts().length > 0) {
		<stages-floating-action-menu
			[buttonTitle]="'ai.widget.title'"
			[darkTheme]="true"
			[iconSize]="'24px'"
			[iconClass]="'ico ico-et-aitemplate'"
			[customButtonClasses]="['ai-feature']"
			[menuItems]="menuItems"
			[triggerCloseHandler]="isLoading"
			[isButtonDisabled]="isLoading || menuItems.length === 0"
			[isLoading]="isLoading"
			[aiAcknowledgmentsState]="aiAcknowledgementState"
		/>
	}
}
